import $ from 'jquery'
import 'slick-carousel'

export default (
  slider = document.querySelector('.checkbox_slider'),
) => {
  $(slider).slick({
    rows: 0,
    arrows: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 15,
    variableWidth: true,
    swipeToSlide: true,
    focusOnSelect: true,
    accessibility: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          variableWidth: false,
        },
      },
    ],
  })
}
